<div class="auth-container reset-password">
	<sf-auth-top-bar></sf-auth-top-bar>
	<div class="card auth-content">
		<div
			*ngIf="!(isConfirmationVisible | async); else confirmation"
			class="reset-password-form"
			[formGroup]="resetPasswordForm"
		>
			<h3 class="sf title">{{ 'sf.module.auth.reset_password.title' | translate }}</h3>
			<span class="caption">{{ 'sf.module.auth.reset_password.caption' | translate }}</span>
			<div class="field-wrapper">
				<sf-input
					class="top"
					formControlName="email"
					id="resetEmail"
					type="email"
					[placeholder]="'sf.module.auth.common.email' | translate"
				>
				</sf-input>
			</div>
			<button
				id="resetButton"
				class="send"
				mat-flat-button
				color="accent"
				(click)="onSend()"
				[disabled]="resetPasswordForm.invalid"
			>
				{{ 'sf.common.send' | translate | uppercase }}
			</button>
		</div>
		<div class="separator"></div>
		<div class="back-to-login-wrapper">
			<span class="link" routerLink="/">{{ 'sf.module.auth.common.back_to_login' | translate }}</span>
		</div>

		<ng-template #confirmation>
			<h3 class="sf title">{{ 'sf.module.auth.reset_password.email_check' | translate }}</h3>
			<span class="caption">{{ 'sf.module.auth.reset_password.confirmation' | translate }}</span>
		</ng-template>
	</div>
	<sf-contact-footer></sf-contact-footer>
</div>
